import React from 'react';
import { Play, Heart, Shuffle } from 'lucide-react';
import SongMenu from '../SongMenu';

const LikedSongs = ({ playSong, songs, likedSongs, toggleLike, user }) => {
  const likedSongsArray = songs.filter(song => likedSongs.has(song.id));

  const handlePlayAll = () => {
    if (likedSongsArray.length > 0) {
      playSong(likedSongsArray[0], likedSongsArray);
    }
  };

  const handleShuffle = () => {
    if (likedSongsArray.length > 0) {
      const shuffled = [...likedSongsArray].sort(() => Math.random() - 0.5);
      playSong(shuffled[0], shuffled);
    }
  };

  return (
    <div className="page-content">
      <div className="liked-songs-header">
        <div className="liked-songs-artwork">
          <div className="liked-songs-gradient">
            <Heart size={48} fill="white" color="white" />
          </div>
        </div>
        <div className="liked-songs-info">
          <span className="playlist-type">PLAYLIST</span>
          <h1 className="playlist-title">Liked Songs</h1>
          <p className="playlist-description">Your favorite mystical tracks</p>
          <div className="playlist-stats">
            <span>{likedSongsArray.length} songs</span>
          </div>
        </div>
      </div>

      {likedSongsArray.length > 0 ? (
        <>
          <div className="playlist-controls">
            <button className="play-all-button" onClick={handlePlayAll}>
              <Play size={20} fill="white" />
              <span>Play All</span>
            </button>
            <button className="shuffle-button" onClick={handleShuffle}>
              <Shuffle size={20} />
              <span>Shuffle</span>
            </button>
          </div>

          <div className="playlist-songs">
            <div className="songs-header">
              <div className="songs-header-index">#</div>
              <div className="songs-header-title">Title</div>
              <div className="songs-header-album">Album</div>
              <div className="songs-header-duration">Duration</div>
              <div className="songs-header-actions"></div>
            </div>

            <div className="songs-list">
              {likedSongsArray.map((song, index) => (
                <div key={song.id} className="song-row">
                  <div className="song-row-index">{index + 1}</div>
                  <div className="song-row-image">
                    <img src={song.albumArt} alt={song.title} />
                    <button 
                      className="row-play-button"
                      onClick={() => playSong(song, likedSongsArray)}
                    >
                      <Play size={16} />
                    </button>
                  </div>
                  <div className="song-row-info">
                    <div className="song-row-title">{song.title}</div>
                    <div className="song-row-artist">{song.artist}</div>
                  </div>
                  <div className="song-row-album">{song.album}</div>
                  <div className="song-row-duration">
                    {Math.floor(song.duration / 60)}:{(song.duration % 60).toString().padStart(2, '0')}
                  </div>
                  <div className="song-row-actions">
                    <button 
                      className="song-row-like liked"
                      onClick={() => toggleLike(song.id)}
                    >
                      <Heart size={16} fill="#9D4EDD" />
                    </button>
                    <SongMenu song={song} user={user} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="empty-liked-songs">
          <div className="empty-state">
            <Heart size={64} className="empty-icon" />
            <h3>Songs you like will appear here</h3>
            <p>Save songs by tapping the heart icon</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LikedSongs;